import styled, { Device, Scale, breakpoints } from '@secretescapes/falcon';
import { mediaQuery } from '@utils/styles.utils';
import { PAGE_CONTAINER_WIDTH } from './SalePageDesktop.utils';
import { Section } from './Section';

// Width of skyscaper ads + spacing: 160px + 32px
const AD_POSITIONING = 192;

export const SalePageDesktopWrapper = styled('div')`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SaleSummaryWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${Scale.l};
  margin-bottom: ${Scale.m};
`;

export const AdditionalInformationContainer = styled('div')`
  max-width: ${PAGE_CONTAINER_WIDTH}px;
  margin: 0 auto;
`;

export const SupplementaryInformationContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderSection = styled(Section)`
  display: flex;
  flex-direction: column;
  gap: ${Scale.m};

  padding-top: ${Scale.xxl};
  padding-bottom: ${Scale.l};
`;

export const GallerySection = styled(Section)`
  padding: 0;
`;

export const RecommendedSalesSection = styled(Section)`
  padding-top: 0;
  width: 100vw;
`;

export const ContentContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${Scale.xl};

  @media ${mediaQuery.tablet} {
    align-items: start;
  }
`;

export const AdWrappedContentContainer = styled('div')`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${Scale.xl};

  @media ${mediaQuery.tablet} {
    align-items: start;
  }
`;

// For truncated text ellipsis to work this can't be a flexbox
export const DetailsContainer = styled('div')`
  > div:not(:last-child) {
    margin-bottom: ${Scale.l};
  }
`;

export const HighlightsContainer = styled('div')`
  a {
    text-decoration: underline !important;
    text-decoration-color: ${({ theme }) => theme.color.secondary60} !important;
  }
`;

export const BadgesWrapper = styled('div')`
  display: flex;
  align-items: center;
  gap: ${Scale.m};
  flex-wrap: wrap;

  > div {
    margin-right: 0;
  }
`;

export const StaticMapContainer = styled('div')`
  border-radius: ${Scale.xxs};
  overflow: hidden;
`;

export const TopBoxContainer = styled('div')`
  width: 100%;
  padding-top: ${Scale.xl};
`;

export const OmnibusDirectiveWrapper = styled('div')`
  max-width: ${PAGE_CONTAINER_WIDTH}px;
`;

interface AdContainerProps {
  side: 'left' | 'right';
}

export const AdContainer = styled('div')<AdContainerProps>`
  position: absolute;
  height: 100%;
  ${({ side }) => (side ? `${side}: -${AD_POSITIONING}px;` : '')}

  @media (max-width: ${breakpoints[Device.desktop]}) {
    display: none;
  }
`;

export const FullWidthAdContainer = styled('div')`
  margin-top: -${Scale.xxl};
`;

interface StickyAdWrapperProps {
  menuHeight: string;
}

export const StickyAdWrapper = styled('div')<StickyAdWrapperProps>`
  position: sticky;
  top: ${({ menuHeight }) => `calc(${Scale.xs} + ${menuHeight})`};
  height: 600px;
  width: 160px;
  overflow: hidden;
`;
